import api from '@api/endpoints';
import { FX_SERVICE_MANAGER_CONSTANTS as types } from '@store/constants';
import { setAlert } from '@store/actions/alertActions';
import { ALERT_STATUS_TYPE } from '@constants';

export const getFxRatesConfig = () => async (dispatch) => {
  try {
    dispatch({
      type: types.GETTING_FX_RATES_CONFIG
    });
    const { data } = await api.fxServiceManager.getFxRatesConfig();

    dispatch({
      type: types.GET_FX_RATES_CONFIG_SUCCESS,
      payload: data
    });
  } catch (error) {
    dispatch(
      setAlert({
        title: error?.message,
        status: ALERT_STATUS_TYPE.ERROR
      })
    );
    dispatch({
      type: types.GET_FX_RATES_CONFIG_FAILURE,
      payload: error?.message
    });
  }
};

export const updateFxRatesConfig = ({
  payload,
  onSuccess,
  onComplete
}) => async (dispatch) => {
  try {
    dispatch({
      type: types.UPDATING_FX_RATES_CONFIG
    });
    const { data } = await api.fxServiceManager.updateFxRatesConfig({ payload });

    dispatch({
      type: types.UPDATE_FX_RATES_CONFIG_SUCCESS,
      payload: data
    });

    onSuccess && onSuccess?.(data);

    dispatch(
      setAlert({
        title: 'FX Rates Config updated successfully!',
        status: ALERT_STATUS_TYPE.SUCCESS
      })
    );
  } catch (error) {
    dispatch(
      setAlert({
        title: error?.message,
        status: ALERT_STATUS_TYPE.ERROR
      })
    );
    dispatch({
      type: types.UPDATE_FX_RATES_CONFIG_FAILURE,
      payload: error?.message
    });
  } finally {
    onComplete && onComplete?.();
  }
};


export const getVanceFxRates = () => async (dispatch) => {
  try {
    dispatch({
      type: types.GETTING_VANCE_FX_RATES
    });
    const { data } = await api.fxServiceManager.getVanceFxRates();

    dispatch({
      type: types.GET_VANCE_FX_RATES_SUCCESS,
      payload: data
    });
  } catch (error) {
    dispatch(
      setAlert({
        title: error?.message,
        status: ALERT_STATUS_TYPE.ERROR
      })
    );
    dispatch({
      type: types.GET_VANCE_FX_RATES_FAILURE,
      payload: error.message
    });
  }
};
